module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(1);
}, /* 1 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.default = void 0;
    var _Spinner = __webpack_require__(2), _Spinner2 = _interopRequireDefault(_Spinner);
    exports.default = _Spinner2.default;
}, /* 2 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _extends2 = __webpack_require__(3), _extends3 = _interopRequireDefault(_extends2), _objectWithoutProperties2 = __webpack_require__(4), _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2), _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(6), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(7), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _reactTransitionGroup = __webpack_require__(10), _SpinnerGlyph = __webpack_require__(11), _SpinnerGlyph2 = _interopRequireDefault(_SpinnerGlyph), Spinner = function(_PureComponent) {
        function Spinner() {
            return (0, _classCallCheck3.default)(this, Spinner), (0, _possibleConstructorReturn3.default)(this, _PureComponent.apply(this, arguments));
        }
        // eslint-disable-next-line react/sort-comp
        return (0, _inherits3.default)(Spinner, _PureComponent), Spinner.prototype.render = function() {
            var _props = this.props, isCompleting = _props.isCompleting, glyphProps = (0, _objectWithoutProperties3.default)(_props, [ "isCompleting" ]);
            return _react2.default.createElement(_reactTransitionGroup.TransitionGroup, {
                component: "div",
                style: {
                    display: "inline-block"
                }
            }, isCompleting ? null : _react2.default.createElement(_SpinnerGlyph2.default, (0, 
            _extends3.default)({
                key: Date.now()
            }, glyphProps)));
        }, Spinner;
    }(_react.PureComponent);
    Spinner.propTypes = {
        /** Time in milliseconds after component mount before spinner is visible. */
        delay: _propTypes2.default.number.isRequired,
        invertColor: _propTypes2.default.bool.isRequired,
        onComplete: _propTypes2.default.func.isRequired,
        size: _propTypes2.default.oneOfType([ _propTypes2.default.oneOf([ "small" ]), _propTypes2.default.oneOf([ "medium" ]), _propTypes2.default.oneOf([ "large" ]), _propTypes2.default.oneOf([ "xlarge" ]), _propTypes2.default.number ]).isRequired,
        /** Whether the process is complete and the spinner should leave */
        isCompleting: _propTypes2.default.bool.isRequired
    }, Spinner.defaultProps = {
        delay: 100,
        isCompleting: !1,
        invertColor: !1,
        onComplete: function() {},
        size: "small"
    }, exports.default = Spinner;
}, /* 3 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/extends");
}, /* 4 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/objectWithoutProperties");
}, /* 5 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("prop-types");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("react-transition-group");
}, /* 11 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _classCallCheck2 = __webpack_require__(5), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _possibleConstructorReturn2 = __webpack_require__(6), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(7), _inherits3 = _interopRequireDefault(_inherits2), _propTypes = __webpack_require__(8), _propTypes2 = _interopRequireDefault(_propTypes), _react = __webpack_require__(9), _react2 = _interopRequireDefault(_react), _Container = __webpack_require__(12), _Container2 = _interopRequireDefault(_Container), _Svg = __webpack_require__(15), _Svg2 = _interopRequireDefault(_Svg), SIZES_MAP = {
        small: 20,
        medium: 30,
        large: 50,
        xlarge: 100
    }, DEFAULT_SIZE = SIZES_MAP.small, SpinnerGlyph = function(_PureComponent) {
        function SpinnerGlyph() {
            var _temp, _this, _ret;
            (0, _classCallCheck3.default)(this, SpinnerGlyph);
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
            return _temp = _this = (0, _possibleConstructorReturn3.default)(this, _PureComponent.call.apply(_PureComponent, [ this ].concat(args))), 
            _this.state = {
                phase: ""
            }, _this.runAfterAnimation = function(callback) {
                function executeCallback(event) {
                    // ignore animation events on the glyph
                    // ignore animation events on the glyph
                    return "svg" !== event.target.tagName && (callback(), parentNode && parentNode.removeEventListener("animationend", executeCallback));
                }
                var _this2 = _this, parentNode = _this2.parentNode;
                return parentNode && parentNode.addEventListener("animationend", executeCallback);
            }, _this.validateSize = function() {
                var size = _this.props.size, spinnerSize = SIZES_MAP[size] || size;
                return "number" == typeof spinnerSize ? spinnerSize : DEFAULT_SIZE;
            }, _ret = _temp, (0, _possibleConstructorReturn3.default)(_this, _ret);
        }
        // eslint-disable-next-line react/sort-comp
        return (0, _inherits3.default)(SpinnerGlyph, _PureComponent), SpinnerGlyph.prototype.componentWillAppear = function(callback) {
            this.enter(callback);
        }, SpinnerGlyph.prototype.componentDidAppear = function() {
            this.idle();
        }, SpinnerGlyph.prototype.componentWillEnter = function(callback) {
            this.enter(callback);
        }, SpinnerGlyph.prototype.componentDidEnter = function() {
            this.idle();
        }, SpinnerGlyph.prototype.componentWillLeave = function(callback) {
            this.leave(callback);
        }, SpinnerGlyph.prototype.componentDidLeave = function() {
            this.props.onComplete();
        }, SpinnerGlyph.prototype.enter = function(callback) {
            var _this3 = this, setEnterPhase = function() {
                _this3.setState({
                    phase: "ENTER"
                }), _this3.runAfterAnimation(callback);
            }, delay = this.props.delay;
            delay ? (this.setState({
                phase: "DELAY"
            }), this.runAfterAnimation(setEnterPhase)) : setEnterPhase();
        }, SpinnerGlyph.prototype.idle = function() {
            this.setState({
                phase: "IDLE"
            });
        }, SpinnerGlyph.prototype.leave = function(callback) {
            this.setState({
                phase: "LEAVE"
            }), this.runAfterAnimation(callback);
        }, SpinnerGlyph.prototype.render = function() {
            var _this4 = this, phase = this.state.phase, _props = this.props, delay = _props.delay, invertColor = _props.invertColor, size = this.validateSize(), strokeWidth = Math.round(size / 10), strokeRadius = size / 2 - strokeWidth / 2;
            return _react2.default.createElement(_Container2.default, {
                delay: delay / 1e3,
                innerRef: function(node) {
                    _this4.parentNode = node ? node.parentElement : null;
                },
                phase: phase,
                size: size
            }, _react2.default.createElement(_Svg2.default, {
                focusable: "false",
                height: size,
                invertColor: invertColor,
                phase: phase,
                size: size,
                viewBox: "0 0 " + size + " " + size,
                width: size,
                xmlns: "http://www.w3.org/2000/svg"
            }, _react2.default.createElement("circle", {
                cx: size / 2,
                cy: size / 2,
                r: strokeRadius
            })));
        }, SpinnerGlyph;
    }(_react.PureComponent);
    SpinnerGlyph.propTypes = {
        /** Time in milliseconds after component mount before spinner is visible. */
        delay: _propTypes2.default.number.isRequired,
        invertColor: _propTypes2.default.bool.isRequired,
        onComplete: _propTypes2.default.func.isRequired,
        size: _propTypes2.default.oneOfType([ _propTypes2.default.oneOf([ "small" ]), _propTypes2.default.oneOf([ "medium" ]), _propTypes2.default.oneOf([ "large" ]), _propTypes2.default.oneOf([ "xlarge" ]), _propTypes2.default.number ]).isRequired
    }, exports.default = SpinnerGlyph;
}, /* 12 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.getContainerAnimation = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(13), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n        from { opacity: 0; }\n        to { opacity: 0; }\n      " ], [ "\n        from { opacity: 0; }\n        to { opacity: 0; }\n      " ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n        from { transform: rotate(50deg); }\n        to { transform: rotate(230deg); }\n      " ], [ "\n        from { transform: rotate(50deg); }\n        to { transform: rotate(230deg); }\n      " ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n        from { transform: rotate(230deg); }\n        to { transform: rotate(510deg); }\n      " ], [ "\n        from { transform: rotate(230deg); }\n        to { transform: rotate(510deg); }\n      " ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n        from { opacity: 1; }\n        to { opacity: 0; }\n      " ], [ "\n        from { opacity: 1; }\n        to { opacity: 0; }\n      " ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n  display: inline-flex;\n  height: ", ";\n  width: ", ";\n\n  /* Rapidly creating and removing spinners will result in multiple spinners being visible while\n   * they complete their exit animations. This rules hides the spinner if another one has been\n   * added. */\n  div + & {\n    display: none;\n  }\n" ], [ "\n  ", "\n  display: inline-flex;\n  height: ", ";\n  width: ", ";\n\n  /* Rapidly creating and removing spinners will result in multiple spinners being visible while\n   * they complete their exit animations. This rules hides the spinner if another one has been\n   * added. */\n  div + & {\n    display: none;\n  }\n" ]), _styledComponents = __webpack_require__(14), _styledComponents2 = _interopRequireDefault(_styledComponents), getContainerAnimation = exports.getContainerAnimation = function(_ref) {
        var delay = _ref.delay, phase = _ref.phase;
        return "DELAY" === phase ? "animation: " + delay + "s " + (0, _styledComponents.keyframes)(_templateObject) + ";" : "ENTER" === phase || "IDLE" === phase ? "animation: 1s ease-in-out forwards " + (0, 
        _styledComponents.keyframes)(_templateObject2) + ";" : "LEAVE" === phase ? "animation: 0.53s ease-in-out forwards " + (0, 
        _styledComponents.keyframes)(_templateObject3) + ",\n      0.2s ease-in-out 0.33s " + (0, 
        _styledComponents.keyframes)(_templateObject4) + ";" : "";
    }, getSize = function(_ref2) {
        var size = _ref2.size;
        return size + "px";
    }, Container = _styledComponents2.default.div(_templateObject5, getContainerAnimation, getSize, getSize);
    Container.displayName = "SpinnerContainer", exports.default = Container;
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");
}, /* 14 */
/***/
function(module, exports) {
    module.exports = require("styled-components");
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    }), exports.svgStyles = exports.getStrokeColor = void 0;
    var _taggedTemplateLiteral2 = __webpack_require__(13), _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2), _templateObject = (0, 
    _taggedTemplateLiteral3.default)([ "\n  ", "\n" ], [ "\n  ", "\n" ]), _templateObject2 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      to { transform: rotate(360deg); }\n    " ], [ "\n      to { transform: rotate(360deg); }\n    " ]), _templateObject3 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      from { stroke-dashoffset: ", "px; }\n      to { stroke-dashoffset: ", "px; }\n    " ], [ "\n      from { stroke-dashoffset: ", "px; }\n      to { stroke-dashoffset: ", "px; }\n    " ]), _templateObject4 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      from { opacity: 0; }\n      to { opacity: 1; }\n    " ], [ "\n      from { opacity: 0; }\n      to { opacity: 1; }\n    " ]), _templateObject5 = (0, 
    _taggedTemplateLiteral3.default)([ "\n      animation: ", ";\n      fill: none;\n      stroke: ", ";\n      stroke-dasharray: ", "px;\n      stroke-dashoffset: ", "px;\n      stroke-linecap: round;\n      stroke-width: ", "px;\n      transform-origin: center;\n    " ], [ "\n      animation: ", ";\n      fill: none;\n      stroke: ", ";\n      stroke-dasharray: ", "px;\n      stroke-dashoffset: ", "px;\n      stroke-linecap: round;\n      stroke-width: ", "px;\n      transform-origin: center;\n    " ]), _templateObject6 = (0, 
    _taggedTemplateLiteral3.default)([ "", "" ], [ "", "" ]), _styledComponents = __webpack_require__(14), _styledComponents2 = _interopRequireDefault(_styledComponents), _theme = __webpack_require__(16), spinnerColor = (0, 
    _theme.themed)({
        light: _theme.colors.N500,
        dark: _theme.colors.N0
    }), spinnerColorInverted = (0, _theme.themed)({
        light: _theme.colors.N0,
        dark: _theme.colors.N0
    }), getStrokeColor = exports.getStrokeColor = function(p) {
        return p.invertColor ? spinnerColorInverted(p) : spinnerColor(p);
    }, svgStyles = exports.svgStyles = (0, _styledComponents.css)(_templateObject, function(props) {
        var strokeWidth = Math.round(props.size / 10), strokeRadius = props.size / 2 - strokeWidth / 2, circumference = Math.PI * strokeRadius * 2, idleRotation = "0.86s cubic-bezier(0.4, 0.15, 0.6, 0.85) infinite " + (0, 
        _styledComponents.keyframes)(_templateObject2), spinUpStroke = "0.8s ease-in-out " + (0, 
        _styledComponents.keyframes)(_templateObject3, circumference, .8 * circumference), spinUpOpacity = "0.2s ease-in-out " + (0, 
        _styledComponents.keyframes)(_templateObject4), activeAnimations = [ idleRotation ];
        return "ENTER" === props.phase && activeAnimations.push(spinUpStroke, spinUpOpacity), 
        (0, _styledComponents.css)(_templateObject5, activeAnimations.join(", "), getStrokeColor, circumference, .8 * circumference, strokeWidth);
    }), Svg = _styledComponents2.default.svg(_templateObject6, svgStyles);
    Svg.displayName = "SpinnerSvg", exports.default = Svg;
}, /* 16 */
/***/
function(module, exports) {
    module.exports = require("@atlaskit/theme");
} ]);


//////////////////
// WEBPACK FOOTER
// ./~/@atlaskit/droplist/~/@atlaskit/spinner/dist/bundle-cjs.js
// module id = 337
// module chunks = 0